"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MemberHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h1", null, "Welcome to The MLC Portal"),
    react_1.default.createElement("p", null, "It's time to Connect to Collect\u2122!")));
exports.default = MemberHeader;
